import { Paper } from '@mui/material';
import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { InsightReportContainer } from '@retail/products/containers';

export function SupplierItemInsightReportPage() {
  return (
    <PageLayout maxWidth="full" fixedHeight>
      <Paper
        sx={{ display: 'flex', flexDirection: 'column', height: '100%', pt: 2, overflow: 'hidden' }}
      >
        <SuspenseWithSentryErrorBoundary>
          <InsightReportContainer />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
